import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse, AttachmentTypeDto, CreateAttachmentTypeRequest } from '../models/models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AttachmentTypeService {
  private readonly apiUrl = `${environment.apiUrl}/attachment-types`;

  constructor(private http: HttpClient) {}

  getAllAttachmentTypes(): Observable<ApiResponse<AttachmentTypeDto[]>> {
    return this.http.get<ApiResponse<AttachmentTypeDto[]>>(this.apiUrl);
  }

  createAttachmentType(request: CreateAttachmentTypeRequest): Observable<ApiResponse<AttachmentTypeDto>> {
    return this.http.post<ApiResponse<AttachmentTypeDto>>(this.apiUrl, request);
  }

  deleteAttachmentType(id: string): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.apiUrl}/${id}`);
  }
}
